import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface PhoneFieldProps {
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
}

export function PhoneField({
  value,
  onChange,
  disabled = false,
}: PhoneFieldProps) {
  return (
    <PhoneInput
      country="us"
      countryCodeEditable={false}
      value={value}
      onChange={(val: string) => {
        const digitsOnly = (val || "").replace(/\D/g, "");
        const localPart = digitsOnly.startsWith("1")
          ? digitsOnly.slice(1)
          : digitsOnly;
        if (localPart.length <= 10) {
          // Always ensure we return with +1 prefix for US numbers
          const formattedNumber = val.startsWith("+") ? val : `+${val}`;
          onChange(formattedNumber);
        }
      }}
      disabled={disabled}
      containerStyle={{ width: "100%" }}
      inputStyle={{
        width: "100%",
        height: "2.5rem",
        fontSize: "1rem",
      }}
    />
  );
}
